module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dKWjI"))).then(() => module.bundle.root('dJXJK'));